/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecoverableFactorMethod } from './RecoverableFactorMethod';
import {
    RecoverableFactorMethodFromJSON,
    RecoverableFactorMethodFromJSONTyped,
    RecoverableFactorMethodToJSON,
    RecoverableFactorMethodToJSONTyped,
} from './RecoverableFactorMethod';

/**
 * 
 * @export
 * @interface RecoverableFactor
 */
export interface RecoverableFactor {
    /**
     * 
     * @type {RecoverableFactorMethod}
     * @memberof RecoverableFactor
     */
    method: RecoverableFactorMethod;
}



/**
 * Check if a given object implements the RecoverableFactor interface.
 */
export function instanceOfRecoverableFactor(value: object): value is RecoverableFactor {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function RecoverableFactorFromJSON(json: any): RecoverableFactor {
    return RecoverableFactorFromJSONTyped(json, false);
}

export function RecoverableFactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecoverableFactor {
    if (json == null) {
        return json;
    }
    return {
        
        'method': RecoverableFactorMethodFromJSON(json['method']),
    };
}

export function RecoverableFactorToJSON(json: any): RecoverableFactor {
    return RecoverableFactorToJSONTyped(json, false);
}

export function RecoverableFactorToJSONTyped(value?: RecoverableFactor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': RecoverableFactorMethodToJSON(value['method']),
    };
}

